module.exports = __webpack_public_path__ + "img/undraw_process.266c2959.svg";